import axios from "axios";
import { API_URL } from "../../constants";

export const VerifyUdataApi = async (body, ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    try {
        let res = await axios.post(API_URL + "user/verify_udata", body);
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }
}